import { call } from 'redux-saga/effects';

import { getInDomain } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';

export function* setSourceRepeatMode({ payload: { mode, sourceId } }) {
  yield call(putAndWait, getInDomain('playback.actions.repeatSource')({ sourceId, mode }));
}
